import React, {Fragment} from 'react';
//NO ESTAMOS USANDO react-select

//EX 18-09-2026: se agrega la prop `disabled`. Antes se le pasaba desde algunos lugares (por ejemplo el
//select de Circ) pero NO se aplicaba al <select>, asi que la condicion se descartaba en silencio.
//EX 21-09-2026 (item §12.1 de TEMAS_PENDIENTES.md): se agrega la prop `id`, que tenia exactamente el mismo
//problema. Los llamadores pasaban id="id_programa", id="id_partido" y compania, y este componente los
//descartaba, asi que TODOS los <label for="..."> que apuntan a esos ids apuntaban a un id inexistente:
//hacer clic en el label no enfocaba nada. Ahora el id se aplica y los labels funcionan (el arreglo vale
//para los 10 archivos que usan SelectInput, no solo para el formulario de expedientes).
//No cambia nada visual: se verifico que index.css no tenga ninguna regla por esos ids.
//Las otras props que se siguen descartando (className, style, title) se dejan asi A PROPOSITO: honrarlas
//SI cambiaria la vista (`.form-control` fija ancho 100% y `my-3` un margen mayor que el `mb-2` que el
//select ya tiene). Borrarlas de los llamadores es limpieza cosmetica, sin efecto observable.
const SelectInput = ({onChange, name, label, options, value, defaultValue, disabled, id}) => {
	//console.log(name);
	//console.log(options);
	//console.log(defaultValue);

  	//const indiceE="Lotes con Servicios";
	if(options.partido){
		console.log(options.partido);
	}

	const opciones = (options) => {
		return options.map( item => {
			console.log(item.partido);
			//console.log(index);
			if(item.partido){
				return  <option value={item.partido}>{item.label} || {item.value}</option>
			} else {
				return 	<option value={item.value}>{item.label}</option>
			}
		})
	}
	/* opciones select
	Pablo Gonzalez; Lucía Matteucci; Teresita Isla; Alexis Goinhex; Nicolas Resa; Ricardo Albina; Estela Retta; Silvana Santinón; Otro
	*/

	if(name ==="partido" || name ==="partido_i"){ // partido seria para probar el input cargando datos desde la url via fetch
		return (
			<select name={name} id={id} defaultValue={defaultValue} disabled={disabled} style={{ background:"white", color:"rgb(131,131,131)", height:"45px" }} className="w-full border-indigo-500 mb-2 p-2 border rounded" onChange={e => onChange(e)} >
				{options.map(item => (<option value={item.value}>{item.value} -- {item.label}</option>))}
			</select>
		)
	} else {
		return (
			<>
    		<select
          name={name}
          id={id}
          value={value} //ADD 27-09-2022
          defaultValue={defaultValue} //ADD 27-09-2022
          disabled={disabled} //EX 18-09-2026: antes la prop se descartaba
          style={{ background:"white", color:"rgb(131,131,131)", height:"45px" }}
          className="w-full border-indigo-500 mb-2 p-2 border rounded"
          onChange={e => onChange(e)}
        >
        	{options.map(item => (<option value={item.value}>{item.label}</option>))}
    		</select>
			</>
    		)
	}
};

export default SelectInput;
//Cambios
//23-07-22: quitar ancho fijo a select
//24-07-22: canbiar background a white

//<option value="uno">"Uno"</option>
//LLAMAR A ESTA FUNCION DA ERROR --> {opciones(options)}
// NO FUNCIONA ---> <select ....> {opciones}</select>
//LLAMAR ASI DA ERROR ---> {options.map(item => (<option value={item}>{item}</option>))}

//ASI OK --->  {options.map(item => (<option value={item.value}>{item.label}</option>))}

/*
<option value="">Seleccionar Encargado...</option>
                <option value="pablo gonzalez">Pablo Gonzalez</option>
                <option value="lucía matteucci">Lucía Matteucci</option>
                <option value="teresita isla">Teresita Isla</option>
                <option value="alexis goinhex">Alexis Goinhex</option>
                <option value="nicolas resa">Nicolas Resa</option>
                <option value="ricardo albina">Ricardo Albina</option>
                <option value="estela retta">Estela Retta</option>
                <option value="silvana santinón">Silvana Santinón</option>
                <option value="otro">Otro</option>


*/
